import storage from '@/utils/localStorage'
import { getUuid } from '@shared/utils/base/index.js'

const storageKey = {
  Uuid: 'Uuid_20211108',
  OtherUserInfo: 'OtherUserInfo_20211108',
  PDFUserInfo: 'PDFUserInfo_20211108'
}

export const cacheGetUUID = () => {
  const uuid = storage.get(storageKey.Uuid)

  if (uuid) { return uuid }

  const newUuid = getUuid()

  storage.set(storageKey.Uuid, newUuid)

  return newUuid
}

/** 第三方用户信息 */
export function CacheGetOtherUserInfo () {
  return storage.get(storageKey.OtherUserInfo)
}
export function CacheSetOtherUserInfo (info) {
  storage.set(storageKey.OtherUserInfo, info, { expires: 365 })
}

/** PDF转换服务的用户信息 */
export function CacheGetPDFUserInfo () {
  return storage.get(storageKey.PDFUserInfo)
}
export function CacheSetPDFUserInfo (info) {
  storage.set(storageKey.PDFUserInfo, info, { expires: 1 }) // token仅有效87400秒，一天多一点
}
